module.exports = __webpack_public_path__ + "img/品牌.3ccb72d2.svg";